import React, { useEffect, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import { useAppState } from '../AppStateContext';
import { styles } from '../styles/styles.js';
import { useNavigate } from 'react-router-dom';

const CardButton = ({ title, onClick }) => (
  <Card
    onClick={onClick}
    className="mb-3 game-card"
    style={
        styles.cardbutton_solo
    }
  >
    <Card.Body>
      <Card.Title style={{ color: 'white', margin: 0 }}>{title}</Card.Title>
    </Card.Body>
  </Card>
);

const Profile = () => {
  const [loading, setLoading] = useState(true);
  const { userProfile, userTier, fetchUserProfile } = useAppState();
  const [tutorialMode, setTutorialMode] = useState(
    localStorage.getItem('tutorialMode') === 'true'
  );
  const navigate = useNavigate();

  useEffect(() => {
    const loadProfile = async () => {
      setLoading(true);
      await fetchUserProfile();
      setLoading(false);
    };

    loadProfile();
  }, [fetchUserProfile]);

  const handleChangePassword = () => {
    navigate('/passwordchangerequest');
  };

  const handleTutorialMode = () => {
    const newMode = !tutorialMode;
    setTutorialMode(newMode);
    localStorage.setItem('tutorialMode', newMode);
  };

  if (loading) {
    return (
      <Container>
        <Col>
          <p style={{ color: 'white' }}>Loading...</p>
        </Col>
      </Container>
    );
  }

  return (
    <div>
        {userProfile && (
          <div className="mb-4">
            <h2 style={{ color: 'white', marginBottom: '20px', marginLeft: '1rem' }}>Profile Information</h2>
            <ul style={{ color: 'white', listStyleType: 'none', padding: 0, marginLeft: '1rem' }}>
              <li>Username: {userProfile.user}</li>
              <li>ID: {userProfile.id}</li>
              <li>Last Login: {new Date(userProfile.last_login_date).toLocaleString()}</li>
              <li>Settings: {JSON.stringify(userProfile.settings)}</li>
              <li>Karma: {userProfile.karma}</li>
              <li>Tier: {userTier}</li>
            </ul>
          </div>
        )}

        <CardButton
          title="Change Password"
          onClick={handleChangePassword}
        />

        <CardButton
          title={`Tutorial Mode: ${tutorialMode ? 'Enabled' : 'Disabled'}`}
          onClick={handleTutorialMode}
        />
        </div>
  );
};

export default Profile;
